import { render, staticRenderFns } from "./SupplierProductsTab.vue?vue&type=template&id=df1db536&scoped=true&"
import script from "./SupplierProductsTab.vue?vue&type=script&lang=js&"
export * from "./SupplierProductsTab.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProductsTab.vue?vue&type=style&index=0&id=df1db536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1db536",
  null
  
)

export default component.exports